export default __webpack_public_path__ + "static/media/admission.d7674a93.png";